import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import { historyTableHeader } from '@/constants/operationSetting/operationSettingHistory';
import { i18n } from '@/locales';
import HistoryRow from '@/views/OperationSetting/HistoryDialog/HistoryRow.vue';
import BrgPagination from '@/components/BrgPagination.vue';
import { operationSettingHistoryActionType } from '@/vuex-store/operation-setting-history/actions';
import vuexStore from '@/vuex-store';
import { operationSettingHistoryGetterType } from '@/vuex-store/operation-setting-history/getters';
import { useOperationHistory } from '@/use/useOperationHistory';
const lc = 'views.operation_setting_history.table.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HistoryTable',
    setup(__props) {
        const { getOperationSettingHistoryList, } = useOperationHistory();
        const locales = {
            tableOnFetching: i18n.t(`${lc}on_fetching`),
            tableDataCanNotLoad: i18n.t(`${lc}data_can_not_load`),
            tableNoDataText: i18n.t(`${lc}no_data_text`),
        };
        const isFetching = computed(() => vuexStore.state.operationSettingHistory.isFetching);
        const isError = computed(() => vuexStore.state.operationSettingHistory.isError);
        const noDataText = computed(() => {
            if (isFetching.value) {
                return locales.tableOnFetching;
            }
            if (isError.value) {
                return locales.tableDataCanNotLoad;
            }
            return locales.tableNoDataText;
        });
        const getterOperationSettingHistoryList = computed(() => vuexStore
            .getters[operationSettingHistoryGetterType.getterOperationSettingHistoryList]);
        const getterPaginationData = computed(() => vuexStore
            .getters[operationSettingHistoryGetterType.getterPaginationData]);
        const currentPage = computed({
            get() {
                return getterPaginationData.value.pageNumber;
            },
            set(pageNumber) {
                vuexStore.dispatch(operationSettingHistoryActionType.setFilterOption, {
                    pageNumber,
                });
                getOperationSettingHistoryList();
            },
        });
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_v_data_table, {
                    hover: "",
                    class: "history-table brg-table",
                    "hide-default-footer": "",
                    "fixed-header": "",
                    "must-sort": "",
                    "no-data-text": noDataText.value,
                    items: getterOperationSettingHistoryList.value,
                    "items-per-page": -1,
                    headers: _unref(historyTableHeader),
                    density: "compact"
                }, {
                    [`item`]: _withCtx(({ item }) => [
                        _createVNode(HistoryRow, {
                            item: item,
                            headers: _unref(historyTableHeader)
                        }, null, 8 /* PROPS */, ["item", "headers"])
                    ]),
                    bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
                    _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["no-data-text", "items", "headers"]),
                _createVNode(BrgPagination, {
                    modelValue: currentPage.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentPage).value = $event)),
                    "class-name": "mt-4",
                    length: getterPaginationData.value.pages
                }, null, 8 /* PROPS */, ["modelValue", "length"])
            ]));
        };
    }
});
